import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';
import type { Module } from '@/auth/modules';
import { Button } from '@/components/ui/button';

const LIBELLES: Record<Module, string> = {
  'tableau-de-bord': 'Tableau de bord',
  tdr: 'Termes de référence',
  fed: 'Engagements (FED)',
  requisitions: 'Réquisitions',
  achats: 'Achats · bons de commande',
  budget: 'Suivi budgétaire',
  plan: 'Plan opérationnel',
  parapheur: 'Parapheur',
  courrier: 'Courrier entrant',
  factures: 'Factures reçues',
  instructions: 'Instructions',
  delegations: 'Délégations',
  tresorerie: 'Trésorerie',
  ressources: 'Ressources et quotes-parts',
  rapports: "Rapports d'exécution",
  administration: 'Administration',
  compte: 'Mon compte',
  rh: 'Mes démarches RH',
  'gestion-rh': 'Gestion RH',
  calendrier: 'Calendrier des absences',
  prets: 'Prêts sociaux',
  procedures: 'Bibliothèque des procédures',
};

/** Page affichée quand l'adresse demandée appartient à un module que le profil ne voit pas. */
export function AccesRefuse({ module }: { module: Module }) {
  return (
    <div className="mx-auto max-w-lg py-16 text-center" data-testid="acces-refuse">
      <ShieldAlert className="mx-auto mb-4 size-10 text-amber-600" />
      <h1 className="text-xl font-semibold">Accès non autorisé</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Le module « {LIBELLES[module]} » ne fait pas partie de votre profil. Si vous pensez devoir y accéder, adressez-vous à l'administrateur, qui peut compléter vos habilitations.
      </p>
      <Button asChild className="mt-6">
        <Link to="/tableau-de-bord">Retour au tableau de bord</Link>
      </Button>
    </div>
  );
}
